<template>
  <component
    :data="data"
    :userFieldInfo="userFieldInfo"
    :is="currentComponent"
  />
</template>

<script>
import VueTypes from 'vue-types'
import UserInfoDirectionInterest from './DirectionInterest'
import CommonCheckBox from './Common'
import * as COMPONENT_TYPE from '../const'

export default {
  name: 'dynamic-checkbox',
  props: {
    data: VueTypes.object.def({}),
    userFieldInfo: VueTypes.object.def({})
  },
  components: {
    UserInfoDirectionInterest,
    CommonCheckBox
  },
  data () {
    return {
      currentComponent: '',
      COMPONENT_TYPE
    }
  },
  watch: {
    'data.details.options': {
      handler (newData, oldData) {
        if (newData !== oldData && newData.length) {
          const isDirectionInterest = newData.findIndex(ele => ele.type === COMPONENT_TYPE.userInfoDirectionInterest) > -1
          if (isDirectionInterest) {
            this.currentComponent = UserInfoDirectionInterest
          } else {
            this.currentComponent = CommonCheckBox
          }
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
